import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useData } from "@/context/DataContext";
import { Reveal, SectionHeader } from "@/components/shared/Reveal";
import { DocumentCard } from "@/components/cards/DocumentCard";

const CATS = ["Alla", "PM & Tilläggsregler", "Startlistor", "Kartor", "Resultat"];

export const DocumentsSection = ({ limit, full, hideHeader }) => {
  const { data } = useData();
  const [cat, setCat] = useState("Alla");
  let docs = data.documents || [];
  if (!docs.length) return null;

  const filtered = cat === "Alla" ? docs : docs.filter((d) => d.category === cat);
  const shown = limit ? filtered.slice(0, limit) : filtered;

  return (
    <section data-testid="documents-section" className={`relative ${hideHeader ? "pt-8 pb-24 sm:pb-32" : "py-24 sm:py-32"}`}>
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        {!hideHeader && (
        <Reveal>
          <div className="flex flex-wrap items-end justify-between gap-4">
            <SectionHeader kicker="Dokumentcenter" title="Dokument" subtitle="PM, tilläggsregler, kartor, startlistor och resultat." />
            {limit && (
              <Link to="/dokument" className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-amber-500 hover:gap-3 transition-all">
                Alla dokument <ArrowRight className="w-4 h-4" />
              </Link>
            )}
          </div>
        </Reveal>
        )}

        {full && (
          <div className="mt-8 flex flex-wrap gap-2">
            {CATS.map((c) => (
              <button
                key={c}
                data-testid={`doc-filter-${c}`}
                onClick={() => setCat(c)}
                className={`rounded-full px-4 py-2 text-xs font-mono uppercase tracking-widest border transition-colors ${
                  cat === c ? "bg-amber-500 text-black border-amber-500" : "border-white/15 text-white/60 hover:border-amber-500/50"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
        )}

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {shown.map((item, i) => (
            <Reveal key={item.id} delay={i * 0.05}>
              <DocumentCard item={item} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
